


export const PRODUCT_REQUEST = "PRODUCT_REQUEST";

export const PRODUCT_FAILURE = "PRODUCT_FAILURE";

// Post

export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";

// Get

export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";

// Patch

export const PATCH_PRODUCT_SUCCESS = "PATCH_PRODUCT_SUCCESS"


// delete
export const DELETE_PRODUCT = "DELETE_PRODUCT"